// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loading_loaderContainer__p3VpW","loader":"Loading_loader__rS1ky","spinloader":"Loading_spinloader__ugz59","spinlogo":"Loading_spinlogo__h-44f"};